export default {"src":"/_next/static/media/add-min-pin.49b1697c.svg","height":36,"width":26,"blurWidth":0,"blurHeight":0};